var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTaskCardAp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "taskCardApGradient",
  x1: 13.5,
  y1: 1.5,
  x2: 2.5,
  y2: 14.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.05,
  stopColor: "#0E4826"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#3BA863"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.222,
  stopColor: "#A5F6C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#ADFED0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.609,
  stopColor: "#09FF6D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.849,
  stopColor: "#41E48D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.902,
  stopColor: "#3BA863"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.996,
  stopColor: "#0E4826"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.44732 1.8387C6.25737 1.50533 7.12469 1.33323 8.00065 1.33203C8.87399 1.33203 9.74065 1.50536 10.554 1.8387C11.3607 2.17203 12.094 2.66536 12.714 3.28536C13.334 3.90536 13.8273 4.6387 14.1607 5.44536C14.494 6.2587 14.6673 7.12536 14.6673 7.9987C14.6673 9.76536 13.9673 11.4654 12.714 12.712C12.0957 13.332 11.3611 13.8237 10.5522 14.159C9.74335 14.4942 8.87622 14.6663 8.00065 14.6654C7.12469 14.6642 6.25737 14.4921 5.44732 14.1587C4.63936 13.8229 3.90541 13.3313 3.28732 12.712C2.66733 12.0938 2.17561 11.3591 1.8404 10.5503C1.50518 9.74139 1.33308 8.87427 1.33399 7.9987C1.33399 6.23203 2.03399 4.53203 3.28732 3.28536C3.90732 2.66536 4.64065 2.17203 5.44732 1.8387ZM4.22732 11.772C5.22732 12.772 6.58732 13.332 8.00065 13.332C9.41399 13.332 10.774 12.772 11.774 11.772C12.774 10.772 13.334 9.41203 13.334 7.9987C13.334 6.58536 12.774 5.22536 11.774 4.22536C11.2783 3.73025 10.69 3.33764 10.0425 3.06997C9.39508 2.8023 8.70124 2.66481 8.00065 2.66536C6.58732 2.66536 5.22732 3.22536 4.22732 4.22536C3.7322 4.72103 3.3396 5.30939 3.07193 5.95683C2.80426 6.60427 2.66677 7.29811 2.66732 7.9987C2.66732 9.41203 3.22732 10.772 4.22732 11.772Z",
  fill: "url(#taskCardApGradient)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.05371 3.12109L12.7178 9.42871L11.5752 11.6748H9.05371L8.05859 9.74609H10.8428L10.5693 9.25195L8.26758 5.08691L7.9834 4.57422L7.6875 5.08008L6.5752 6.97754L5.64062 5.22363L6.75098 3.12109H9.05371ZM6.38477 7.30566L6.47461 7.46973L7.54004 9.42871H5.64062L4.48145 11.5557L3.28125 9.42871L4.48145 7.29395L6.38477 7.30566Z",
  fill: "url(#taskCardApGradient)"
})));
export default SvgTaskCardAp;